import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Cake } from 'lucide-react';

const Header = () => {
  const [menuAberto, setMenuAberto] = useState(false);
  const location = useLocation();

  const menuItems = [
    { nome: 'Início', path: '/' },
    { nome: 'Produtos', path: '/produtos' },
    { nome: 'Galeria', path: '/galeria' },
    { nome: 'Feedbacks', path: '/feedbacks' },
    { nome: 'Sobre Nós', path: '/sobre' },
    { nome: 'Contato', path: '/contato' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-pastelaria">
      <nav className="nav-container">
        <Link to="/" className="logo-link">
          <Cake className="logo-icon" />
          <span className="logo-text">Mordida de Sonho</span>
        </Link>

        {/* Desktop Menu */}
        <ul className="nav-menu desktop-menu">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
              >
                {item.nome}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setMenuAberto(!menuAberto)}
          aria-label="Toggle menu"
        >
          {menuAberto ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Menu */}
        {menuAberto && (
          <div className="mobile-menu">
            <ul className="mobile-menu-list">
              {menuItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`mobile-nav-link ${isActive(item.path) ? 'active' : ''}`}
                    onClick={() => setMenuAberto(false)}
                  >
                    {item.nome}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
